import React, { useEffect, useState } from 'react';
import { Banner } from '../ui/Banner';
import { isLocalStorageNearFull, getLocalStorageUsagePercent } from '../../utils/storageQuota';
import { subscribePersistFailure } from '../../app/store';
/**
 * StorageWarningBanner — Surfaces localStorage quota warnings to users.
 *
 * Shows a dismissible warning banner when localStorage usage exceeds 80%.
 * Checks on mount and every 60 seconds thereafter.
 *
 * Addresses: RES-4 (storageQuota.ts not surfaced to users)
 */
export function StorageWarningBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [usagePercent, setUsagePercent] = useState(0);
  const [isNearFull, setIsNearFull] = useState(false);
  // W20: surface an actual persist failure the moment it happens, instead of
  // waiting for the 60s usage poll to cross 80%. A real write-failure means
  // recent progress was not saved — show the critical message immediately and
  // un-dismiss so the user cannot miss it.
  const [writeFailed, setWriteFailed] = useState(false);
  useEffect(() => {
    function check() {
      setIsNearFull(isLocalStorageNearFull());
      setUsagePercent(getLocalStorageUsagePercent());
    }
    check();
    const interval = setInterval(check, 60000);
    const unsubscribe = subscribePersistFailure(() => {
      setWriteFailed(true);
      setDismissed(false);
      check();
    });
    return () => {
      clearInterval(interval);
      unsubscribe();
    };
  }, []);
  if (!isNearFull && !writeFailed || dismissed) return null;
  const isCritical = writeFailed || usagePercent > 95;
  return <Banner variant={isCritical ? 'danger' : 'warning'} onDismiss={() => setDismissed(true)} className="rounded-none sm:rounded-none border-x-0 border-t-0" data-id="element-2700" data-mp="24gj9r5o8qipk">
      
      {writeFailed ? 'Opslaan mislukt — je laatste voortgang is mogelijk niet bewaard. Opslag is vol. Neem contact op met je leerkracht of beheerder.' : isCritical ? 'Opslag bijna vol — gegevens kunnen verloren gaan. Neem contact op met je leerkracht of beheerder.' : `Opslag raakt vol (${usagePercent}% gebruikt). Overweeg oude gegevens op te ruimen.`}
    </Banner>;
}